// extracted by mini-css-extract-plugin
export default {"title":"Charts_title_e3cdc","chart":"Charts_chart_ff416","legendItem":"Charts_legendItem_b05d8"};